import { API } from '~apis/axios/instance';
import { Trade } from '~components/Trade';
import { ResponseBase } from '~types/response';

export interface GetTradesResponse extends ResponseBase {
  data: {
    items: Trade[];
    current: number;
    hasNext: boolean;
    total: number;
  };
}

/**
 * 거래 목록 조회
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/rover-company-trade-controller/list_1
 * @param companyId 회사 id
 * @param page 페이지
 * @param size 사이즈
 * @returns
 */
export const getTrades = async (companyId: string, page: number, size: number) =>
  API.get<GetTradesResponse>(`/api/v2/companies/${companyId}/trades`, {
    params: {
      page: page,
      size: size,
    },
  });
